import { useTranslation } from "react-i18next";
import "../../../../css/wallet/SharedWallet/BankAccounts.css";
import { useEffect, useState } from "react";
import AddBankAccounts from "./AddBankAccounts";
import { bankAccountsRequest } from "./BankAccountsRequest";

function BankAccounts({ theme }) {
  const { t } = useTranslation();

  const [addBankAccountsStatus, setAddBankAccountsStatus] = useState(false);

  const [requestStatus, setRequestStatus] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    bankAccountsRequest(setRequestStatus, setData);
  }, []);

  return (
    <div className="bankAccountsContentDiv">
      <div className={`bankAccountssHeaderDiv ${theme}`}>
        <div>{t("Bank Accounts")}</div>
        <button
          onClick={() => {
            setAddBankAccountsStatus(true);
          }}
          className="textButton"
        >
          {t("Add")}
        </button>

        {addBankAccountsStatus && (
          <AddBankAccounts
            theme={theme}
            setAddBankAccountsStatus={setAddBankAccountsStatus}
            setData={setData}
          ></AddBankAccounts>
        )}
      </div>

      <div className="bankAccountsDiv">
        {data.length > 0 ? (
          data.map((item, index) => {
            return (
              <div key={index} className="bankAccountDiv">
                <img src="/images/bank_card_512.png"></img>

                <div className="bankAccountNameDiv">{item.name}</div>
                <div className="bankAccountNumberDiv">{item.card_number}</div>
                <div className="bankAccountNumber2Div">{item.card_number2}</div>
              </div>
            );
          })
        ) : (
          <div className="emptyDiv">
            <img src="/images/empty512.png"></img>
            <div className="emptyTitleDiv">{t("Empty")}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default BankAccounts;
